<template>
	<div>
		<div class="bigBox">
			<div class="leftCont">
				<div class="banner4">
					<div class="mendio2">
						<div class="name1">加入我们，</div>
						<div class="name2">将能力、积累、资源变现</div> 
						<div class="Intro">(电话或微信给我：159 8989 7729)</div>
						<el-button style='display: none;' type="text" class="Ufree" @click="dvJoin = true"><span style="color: #fff !important;margin-left: unset !important;">合伙人加入</span></el-button> 
					</div>
				</div>
				<div class="priceBox">
					<div class="title cis">市场运营/合伙人</div>
					<div class="fstPrice">
						<div class="fsttitle">合伙人</div>
						<div class="sub-title">B端资源、BD能力或赚钱意愿强烈</div>
						<div class="desc">
							<li>品牌商、厂家、连锁店生态圈解决方案销售;</li> 
							<li>餐饮、服装、宠物等实体店解决方案销售;</li> 
							<li>负责代理招募</li>   
						</div>
						<p class="income">
							¥ 50W +
							<span>/年</span>
						</p>
					</div>
					<div class="secPice">
						<div class="fsttitle">运营主管</div>
						<div class="sub-title">4年+，文凭不限</div>
						<div class="desc">
							<li>有运营经验及运营管理经验;</li> 
							<li>制订平台内容运营，包括图文、直播、短视频等运营策略;</li> 
							<li>能独立筹划大型市场活动，根据业务目标制定营销方案，策划与执行周期型促销活动推广工作</li>   
						</div>
						<p class="income">
							¥ 8K +
							<span>/月</span>
						</p>
					</div>
					<div class="thrPrice">
						<div class="fsttitle">部门助理</div>
						<div class="sub-title">4年+，大专以上文凭</div>
						<div class="desc">
							<li>协助经理处理行政事务工作及部门内部日常事务工作;</li> 
							<li>参与公司绩效管理、考勤等工作;</li> 
							<li>协助办理面试、会议、培训、公司集体活动组织与安排，节假日慰问等；</li>   
							<li>对外相关部门联络接待，对内接待来访等工作</li>  
						</div>
						<p class="income">
							¥ 8K +
							<span>/月</span>
						</p>
					</div>
				</div> 
				<div class="priceBox">
					<div class="title cis">技术部</div>
					<div class="fstPrice">
						<div class="fsttitle">Java高级工程师</div>
						<div class="sub-title">5年+，文凭不限</div>
						<div class="desc">
							<li>5年以上java开发经验，java基础扎实，熟悉io、多线程、集合等基础框架;</li> 
							<li>精通springboot、spring cloud等框架，熟悉Linux下的常用命令，熟悉MySQL数据库;</li>  
							<li>熟悉分布式、缓存、消息、搜索等机制;</li>
							<li>有团队管理或架构经验优先</li>
						</div>
						<p class="income">
							¥ 18K +
							<span>/月</span>
						</p>
					</div>
					<div class="secPice">
						<div class="fsttitle">前端工程师</div>
						<div class="sub-title">4年+，大专以上文凭</div>
						<div class="desc">
							<li>精通vue、uniapp、elementui等框架;</li> 
							<li>有微信公众平台、小程序开发经验者优先;</li>  
							<li>具备良好的团队合作、沟通能力，能够理解和适应变化</li> 
						</div>
						<p class="income">
							¥ 12K +
							<span>/月</span>
						</p>
					</div>
					<div class="thrPrice">
						<div class="fsttitle">测试工程师</div>
						<div class="sub-title">4年+，大专以上文凭</div>
						<div class="desc">
							<li>熟悉软件的测试技术、方法、流程，熟悉性能测试的流程，掌握性能测试工具LoadRunner使用;</li> 
							<li>熟悉软件工程，软件测试基本理论知识，测试规范，测试流程及测试方法;</li> 
							<li>有Web和移动应用的测试经验</li>   
						</div>
						<p class="income">
							¥ 11K +
							<span>/月</span>
						</p>
					</div>
				</div>
				<div class="emtyBox"></div>
			</div>
			<right-cont :activeIndex="activeIndex"></right-cont> 
			<el-dialog title="" :visible.sync="dvJoin" width="30%" :before-close="handleClose">
				<div>
					<img class="pop-pic" src="../assets/images/qr_join.png" />
					<div class="free-use">扫码加入</div>
				</div>
			</el-dialog>  
		</div>
	</div>
</template>

<script>
	import msgFoot from '../components/msgFoot.vue'
	import rightCont from '../components/rightCont.vue'
	export default {
		components: {
			msgFoot,
			rightCont
		},
		data() {
			return {
				activeIndex: '4',
				dialogVisible: false,
				dvJoin: false 
			}
		},
		methods: {
			handleClose(done) {
				done();
			}
		},
		mounted() {
			window.scroll(0, 0);
		}
	}
</script>

<style>
	@media screen and (max-width: 600px) {
		.income {
			font-weight: 500;
			font-size: 6.4vw;
			color: #ff6a00;
			line-height: 12.8vw;
		}

		.priceBox {
			text-align: center;
			overflow: hidden;
			padding: 5vw;
			margin-left: 0;
			overflow: hidden;
		}

		.grid-add {
			background-color: #f7f8fa;
			overflow: hidden;
			color: #666;
			text-align: center;
			padding: 0 5vw;
		}

		.name1 {
			font-size: 3.4vw;
			color: #fff;
			padding-top: 2vw;
			text-align: center;
		}

		.name2 {
			font-size: 3.4vw;
			color: #fff;
			margin-top: 2vw;
			text-align: center;
		}

		.fstPrice {
			padding: 10vw;
			-webkit-box-shadow: 0 0 2vw 0 rgba(0, 0, 0, .1);
			box-shadow: 0 0 2vw 0 rgba(0, 0, 0, .1);
			background-color: #fff;
			margin: 0 auto;
			margin-top: 2vw;
			min-height: 32vw;
		}

		.secPice {
			padding: 10vw;
			-webkit-box-shadow: 0 0 4vw 0 rgba(0, 0, 0, .1);
			box-shadow: 0 0 4vw 0 rgba(0, 0, 0, .1);
			background-color: #fff;
			margin: 0 auto;
			margin-top: 4vw;
			min-height: 32vw;
		}

		.thrPrice {
			padding: 10vw;
			-webkit-box-shadow: 0 0 4vw 0 rgba(0, 0, 0, .1);
			box-shadow: 0 0 4vw 0 rgba(0, 0, 0, .1);
			background-color: #fff;
			margin: 0 auto;
			margin-top: 4vw;
			min-height: 32vw;
		}

		.forms {
			width: 100%;
			/* margin: 65px auto 56px; */
			border: 1px solid #e5e5e5;
		}

		.comCont1 {
			flex: 1;

		}

		.exlBox {
			margin-left: 3vw;
			margin-right: 3vw;
			border-top: 1px #ddd solid;
			border-left: 1px #ddd solid;
			line-height: 8vw;
			font-size: 3.6vw;
			margin-top: 4vw;
		}

		.exlbox-cont {
			flex: 1;
			border-right: 1px #ddd solid;
		}

		.exlbox1 {
			border-bottom: 1px #ddd solid;
			flex: 1;
			display: flex;

		}

		.ftitle {
			display: flex;
			background-color: #f9f9f9;
		}

		.add-title {
			margin-top: 2.4vw;
			margin-bottom: 1.2vw;
			font-size: 1.8vw;
			color: #333;
			line-height: 1.8vw;
		} 

		.fsttitle {
			font-size: 3.6vw;
			color: #333;
			line-height: 3.6vw;
			font-weight: 600;
		}

		.sub-title {
			font-size: 2.8vw;
			color: #666;
			text-align: center;
			line-height: 4vw;
			height: 4vw;
			margin-top: 1.6vw;
			margin-bottom: 1.6vw;
		}

		.desc {
			font-size: 2.4vw;
			color: #666;
			text-align: left;
			line-height: 4vw;
			margin-bottom: 1.6vw;
			height: auto;
			min-height: 16vw;
		}

		span {
			margin-left: 1vw;
			font-size: 1.4vw;
			font-weight: 300;
			color: #999;
		}

		.tsb {
			color: #ff6a00;
		}
	}

	@media screen and (min-width: 600px) and (max-width: 1200px) {
		.income {
			font-weight: 500;
			font-size: 6.4vw;
			color: #ff6a00;
			line-height: 12.8vw;
		}

		.priceBox {
			text-align: center;
			overflow: hidden;
			padding: 5vw;
			margin-left: 0;
			overflow: hidden;
		}

		.grid-add {
			background-color: #f7f8fa;
			overflow: hidden;
			color: #666;
			text-align: center;
			padding: 0 5vw;
		}

		.name1 {
			font-size: 5.4vw;
			color: #fff;
			padding-top: 2vw;
			text-align: center;
		}

		.name2 {
			font-size: 5.4vw;
			color: #fff;
			margin-top: 2vw;
			text-align: center;
		}

		.fstPrice {
			padding: 10vw;
			-webkit-box-shadow: 0 0 2vw 0 rgba(0, 0, 0, .1);
			box-shadow: 0 0 2vw 0 rgba(0, 0, 0, .1);
			background-color: #fff;
			margin: 0 auto;
			margin-top: 2vw;
			min-height: 32vw;
		}

		.secPice {
			padding: 10vw;
			-webkit-box-shadow: 0 0 4vw 0 rgba(0, 0, 0, .1);
			box-shadow: 0 0 4vw 0 rgba(0, 0, 0, .1);
			background-color: #fff;
			margin: 0 auto;
			margin-top: 4vw;
			min-height: 32vw;
		}

		.thrPrice {
			padding: 10vw;
			-webkit-box-shadow: 0 0 4vw 0 rgba(0, 0, 0, .1);
			box-shadow: 0 0 4vw 0 rgba(0, 0, 0, .1);
			background-color: #fff;
			margin: 0 auto;
			margin-top: 4vw;
			min-height: 32vw;
		}

		.forms {
			width: 100%;
			/* margin: 65px auto 56px; */
			border: 1px solid #e5e5e5;
		}

		.comCont1 {
			flex: 1;

		}

		.exlBox {
			margin-left: 3vw;
			margin-right: 3vw;
			border-top: 1px #ddd solid;
			border-left: 1px #ddd solid;
			line-height: 8vw;
			font-size: 3.6vw;
			margin-top: 4vw;
		}

		.exlbox-cont {
			flex: 1;
			border-right: 1px #ddd solid;
		}

		.exlbox1 {
			border-bottom: 1px #ddd solid;
			flex: 1;
			display: flex;

		}

		.ftitle {
			display: flex;
			background-color: #f9f9f9;
		}

		.add-title {
			margin-top: 2.4vw;
			margin-bottom: 1.2vw;
			font-size: 1.8vw;
			color: #333;
			line-height: 1.8vw;
		}
 

		.fsttitle {
			font-size: 3.6vw;
			color: #333;
			line-height: 3.6vw;
			font-weight: 600;
		}

		.sub-title {
			font-size: 2.8vw;
			color: #666;
			text-align: center;
			line-height: 4vw;
			height: 4vw;
			margin-top: 1.6vw;
			margin-bottom: 1.6vw;
		}

		.desc {
			font-size: 2.4vw;
			color: #666;
			text-align: left;
			line-height: 4vw;
			margin-bottom: 1.6vw;
			height: auto;
			min-height: 16vw;
		}

		span {
			margin-left: 1vw;
			font-size: 1.4vw;
			font-weight: 300;
			color: #999;
		}

		.tsb {
			color: #ff6a00;
		}
	}

	@media screen and (min-width: 1200px) {
		.sec-emtybox {
			width: 125px;
			float: left;
			height: 50px;
			margin-left: 20px;
		}

		.comCont1 {
			flex: 1;
			width: 191px;
			height: 40px;
			line-height: 40px;
			text-align: left;
			padding-left: 14px;
		}

		.emtyBox {
			height: 50px;
			width: 100%;
		}

		.forms {
			width: 790px;
			margin: 65px auto 56px;
			border: 1px solid #e5e5e5;
		}

		.try {
			width: 170px;
			height: 40px;
			text-align: center;
			display: block;
			margin: 32px 0 15px;
			line-height: 40px;
			border-radius: 3px;
			background-color: #fff;
			color: #8558fa;
		}

		.priceBox {
			text-align: center;
			overflow: hidden;
			padding-bottom: 20px;
			margin-left: 0;
			/* width: 872px; */
			overflow: hidden;
		}

		.grid-add {
			width: 790px;
			margin: 0 auto;
			background-color: #f7f8fa;
			overflow: hidden;
			color: #666;
			text-align: center;
		}

		.name1 {
			font-size: 34px;
			color: #fff;
			line-height: 44px;
			padding-top: 10px;
		}

		.name2 {
			font-size: 34px;
			color: #fff;
			line-height: 44px;
		}

		.fstPrice {
			float: left;
			width: 300px;
			padding: 25px;
			-webkit-box-shadow: 0 0 20px 0 rgba(0, 0, 0, .1);
			box-shadow: 0 0 20px 0 rgba(0, 0, 0, .1);
			background-color: #fff;
			margin-left: 50px;
			min-height: 320px;
		}

		.secPice {
			float: left;
			width: 300px;
			padding: 25px;
			-webkit-box-shadow: 0 0 20px 0 rgba(0, 0, 0, .1);
			box-shadow: 0 0 20px 0 rgba(0, 0, 0, .1);
			background-color: #fff;
			margin-left: 25px;
			min-height: 320px;
		}

		.thrPrice {
			float: left;
			width: 300px;
			padding: 25px;
			-webkit-box-shadow: 0 0 20px 0 rgba(0, 0, 0, .1);
			box-shadow: 0 0 20px 0 rgba(0, 0, 0, .1);
			background-color: #fff;
			margin-left: 25px;
			min-height: 320px;
		}

		.exlBox {
			margin-left: 40px;
			margin-right: 40px;
			border-top: 1px #ddd solid;
			border-left: 1px #ddd solid;
			line-height: 40px;
			font-size: 18px;
			margin-top: 40px;
		}

		.exlbox-cont {
			flex: 1;
			border-right: 1px #ddd solid;
		}

		.exlbox1 {
			border-bottom: 1px #ddd solid;
			flex: 1;
			display: flex;

		}

		.tsb {
			color: #ff6a00;
		}

		.iconPic {
			width: 20px;
			height: 20px;
			margin-top: 10px;
		}

		.cis {
			margin-bottom: 50px;
		}

		.ftitle {
			display: flex;
			background-color: #f9f9f9;
		}

		.comCont {
			display: flex;
			border-top: 1px #e5e5e5 solid;
			align-items: center;
		}

		.comCont2 {
			flex: 1;
			width: 191px;
			height: 40px;
			text-align: center;
			border-left: 1px solid #e5e5e5;
		}

		.comCont3 {
			flex: 1;
			width: 191px;
			height: 40px;
			text-align: center;
			border-left: 1px solid #e5e5e5;
		}

		.comCont4 {
			flex: 1;
			width: 191px;
			height: 40px;
			text-align: center;
			border-left: 1px solid #e5e5e5;
		}

		.compare {
			font-size: 12px;
			line-height: 32px;
			padding-left: 14px;
			text-align: left;
			height: 32px;
			color: #333;
			background-color: #f9f9f9;
			border-top: 1px solid #e5e5e5;
		}

		.title-text1 {
			flex: 1;
			width: 191px;
			height: 40px;
			line-height: 40px;
			text-align: center;
			font-weight: 800;
			padding-left: 14px;
		}

		.title-text2 {
			flex: 1;
			width: 191px;
			height: 40px;
			line-height: 40px;
			text-align: center;
			border-left: 1px solid #e5e5e5;
			font-weight: 800;
		}

		.title-text3 {
			flex: 1;
			width: 191px;
			height: 40px;
			line-height: 40px;
			text-align: center;
			border-left: 1px solid #e5e5e5;
			font-weight: 800;
		}

		.title-text4 {
			flex: 1;
			width: 191px;
			height: 40px;
			line-height: 40px;
			text-align: center;
			border-left: 1px solid #e5e5e5;
			font-weight: 800;
		}

		.add-title {
			margin-top: 24px;
			margin-bottom: 12px;
			font-size: 18px;
			color: #333;
			line-height: 18px;
		} 

		.fsttitle {
			font-size: 18px;
			color: #333;
			line-height: 18px;
			font-weight: 800;
		}

		.sub-title {
			font-size: 14px;
			color: #666;
			text-align: center;
			line-height: 20px;
			height: 40px;
			margin-top: 16px;
			margin-bottom: 16px;
		}

		.desc {
			font-size: 14px;
			color: #666;
			text-align: left;
			line-height: 20px;
			margin-bottom: 16px;
			height: auto;
			min-height: 120px;
		}

		.income {
			font-weight: 500;
			font-size: 32px;
			color: #ff6a00;
			line-height: 32px;
		}

		span {
			margin-left: 10px;
			font-size: 14px;
			font-weight: 300;
			color: #999;
		}
	}
</style>
